import React from "react";
import { useIntl } from "react-intl";
import NewLinkTab from "~/components/profile/NewLinkTab";
import ProfileNavbar from "~/components/profile/ProfileNavbar";

interface IVendorProfileNavbarProps {
  tab: string;
  vendorSlug: string;
  preview: "current" | "makers" | null | undefined;
  canShowAllTabs: boolean;
  canShowGovernmentsTab: boolean;
  feedCount: number;
  productsCount: number;
  storiesCount: number;
  projectsCount: number;
  governmentConnectionsCount: number;
  highlightsCount: number;
}

export default function VendorProfileNavbar({
  tab,
  vendorSlug,
  preview,
  canShowAllTabs,
  canShowGovernmentsTab,
  feedCount,
  productsCount,
  storiesCount,
  projectsCount,
  governmentConnectionsCount,
  highlightsCount,
}: IVendorProfileNavbarProps) {
  const intl = useIntl();

  return (
    <ProfileNavbar>
      {canShowAllTabs && (
        <NewLinkTab
          href="/vendors/[vendorSlug]/[[...content]]"
          as={paramsWithPreview(
            {
              content: "connect",
              vendorSlug: vendorSlug,
            },
            preview,
          )}
          title={intl.formatMessage({ defaultMessage: "Activity", id: "ZmlNQ3" })}
          count={feedCount}
          active={tab === "connect"}
        />
      )}

      <NewLinkTab
        href="/vendors/[vendorSlug]/[[...content]]"
        as={paramsWithPreview(
          {
            content: "products",
            vendorSlug: vendorSlug,
          },
          preview,
        )}
        title={intl.formatMessage({ defaultMessage: "Products", id: "7NFfmz" })}
        count={productsCount}
        active={tab === "products"}
      />

      {canShowAllTabs && (
        <NewLinkTab
          href="/vendors/[vendorSlug]/[[...content]]"
          as={paramsWithPreview(
            {
              content: "stories",
              vendorSlug: vendorSlug,
            },
            preview,
          )}
          title={intl.formatMessage({ defaultMessage: "Stories", id: "Ldxym4" })}
          count={storiesCount}
          active={tab === "stories"}
        />
      )}

      {canShowAllTabs && (
        <NewLinkTab
          href="/vendors/[vendorSlug]/[[...content]]"
          as={paramsWithPreview(
            {
              content: "projects",
              vendorSlug: vendorSlug,
            },
            preview,
          )}
          title={intl.formatMessage({ defaultMessage: "Projects", id: "UxTJRa" })}
          count={projectsCount}
          active={tab === "projects"}
        />
      )}

      {canShowGovernmentsTab && (
        <NewLinkTab
          href="/vendors/[vendorSlug]/[[...content]]"
          as={paramsWithPreview(
            {
              content: "governments",
              vendorSlug: vendorSlug,
            },
            preview,
          )}
          title={intl.formatMessage({ defaultMessage: "Governments", id: "qnQX9U" })}
          count={governmentConnectionsCount}
          active={tab === "governments"}
        />
      )}

      {canShowAllTabs && (
        <NewLinkTab
          href="/vendors/[vendorSlug]/[[...content]]"
          as={paramsWithPreview(
            {
              content: "highlights",
              vendorSlug: vendorSlug,
            },
            preview,
          )}
          title={intl.formatMessage({ defaultMessage: "Highlights", id: "KGmQjH" })}
          count={highlightsCount}
          active={tab === "highlights"}
        />
      )}
    </ProfileNavbar>
  );
}

function paramsWithPreview(
  { content, vendorSlug }: { content: string; vendorSlug: string },
  preview?: "makers" | "current" | null,
) {
  if (preview) {
    if (preview === "makers") {
      return `/vendors/${vendorSlug}/${content}?preview=1&makers=1`;
    }
    return `/vendors/${vendorSlug}/${content}?preview=1`;
  }

  return `/vendors/${vendorSlug}/${content}`;
}
